// The logo on every screen before sign-in — sign-in, the two-factor step and
// the password screens (auth-supabase ResetPassword). One piece, so they can
// never disagree.
//
// The site's own logo when a site admin saved one (Settings → Look and Feel
// → Sign-in logo), else the product's Zebra Stride logo. Which one is known
// from /api/branding/theme (signInLogo.js); until the answer is in, a first-
// time visitor sees an empty space of the logo's height — never the product's
// logo flashing before the site's. If the site's picture fails to load, the
// product's logo shows: a sign-in screen always has a logo.

import { useEffect, useState } from 'react';
import { client as httpClient } from '@platform/http/api-client';
import { BRAND_NAME } from '@client/config/client.config';
import strideLogo from '@app/assets/zebra-stride-logo.png';
import { readSignInLogo, cacheSignInLogo, signInLogoFromTheme, signInLogoSrc } from '../signInLogo';

export default function SignInLogo() {
  // undefined = not known yet; null = the product's logo; a string = the site's
  const [version, setVersion] = useState(readSignInLogo);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let on = true;
    httpClient.get('/api/branding/theme')
      .then((r) => {
        if (!on) return;
        const v = signInLogoFromTheme(r.data);
        cacheSignInLogo(v);
        setVersion(v);
      })
      // Offline or the route is down: keep what this browser knew, else the product's logo.
      .catch(() => { if (on) setVersion((v) => (v === undefined ? null : v)); });
    return () => { on = false; };
  }, []);

  if (version === undefined) return <div className="landing-brand-placeholder" aria-hidden="true" />;
  if (version && !failed) {
    return (
      <img
        src={signInLogoSrc(version)}
        alt={BRAND_NAME}
        className="landing-brand-logo landing-brand-logo--site"
        onError={() => setFailed(true)}
      />
    );
  }
  return <img src={strideLogo} alt="Zebra Stride" className="landing-brand-logo" />;
}
